import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static classes = ['enter']

  declare readonly hasEnterClass: boolean
  declare readonly enterClass: string
  classTimeout: NodeJS.Timeout
  connect() {
    clearTimeout(this.classTimeout)
    if (this.hasEnterClass) {
      this.element.classList.add(this.enterClass)
      this.classTimeout = setTimeout(() => this.element.classList.remove(this.enterClass), 300)
    }
  }
}
